var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 45 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 42.4999V44.9999H0V42.4999L5 37.4999V22.4999C5 14.7499 10.075 7.92491 17.5 5.72491V4.99991C17.5 3.67383 18.0268 2.40206 18.9645 1.46437C19.9021 0.526693 21.1739 -9.15527e-05 22.5 -9.15527e-05C23.8261 -9.15527e-05 25.0979 0.526693 26.0355 1.46437C26.9732 2.40206 27.5 3.67383 27.5 4.99991V5.72491C34.925 7.92491 40 14.7499 40 22.4999V37.4999L45 42.4999ZM27.5 47.4999C27.5 48.826 26.9732 50.0978 26.0355 51.0354C25.0979 51.9731 23.8261 52.4999 22.5 52.4999C21.1739 52.4999 19.9021 51.9731 18.9645 51.0354C18.0268 50.0978 17.5 48.826 17.5 47.4999",
    fill: "#314A72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a6b41fef7fc5014282e724367520d50b.svg";
export { ForwardRef as ReactComponent };